import React from 'react';
import { NavLink } from 'react-router-dom';
import { cn } from '../../lib/cn';

const LINKS = [
  { label: 'Companies', path: '/organizations/companies' },
  { label: 'Teams', path: '/organizations/teams' },
  { label: 'Departments', path: '/organizations/departments' },
  { label: 'User Management', path: '/organizations/users' },
];

export const OrgSubnav: React.FC = () => (
  <nav className="-mt-3 mb-4 flex gap-5" data-print-hide>
    {LINKS.map((l) => (
      <NavLink key={l.path} to={l.path}
        className={({ isActive }) =>
          cn('cap-label pb-1', isActive && 'border-b border-accent text-accent')
        }>
        {l.label}
      </NavLink>
    ))}
  </nav>
);
